/*! lg-video - v1.4.0 - November-07-2020
* http://sachinchoolur.github.io/lightGallery
* Copyright (c) 2020 Sachin N; Licensed GPLv3 */
!function (a, b) {
  "function" == typeof define && define.amd ? define(["jquery"], function (a) {
    return b(a);
  }) : "object" == typeof module && module.exports ? module.exports = b(require("jquery")) : b(a.jQuery);
}(this, function (a) {
  !function () {
    "use strict";

    function b(a, b, c, d) {
      var e = this;
      if (e.core.$slide.eq(b).find(".lg-video").append(e.loadVideo(c, "lg-object", !0, b, d)), d) if (e.core.s.videojs) try {
        videojs(e.core.$slide.eq(b).find(".lg-html5").get(0), e.core.s.videojsOptions, function () {
          !e.videoLoaded && e.core.s.autoplayFirstVideo && this.play();
        });
      } catch (a) {
        console.error("lightGallery:- Make sure you have included videojs");
      } else !e.videoLoaded && e.core.s.autoplayFirstVideo && e.core.$slide.eq(b).find(".lg-html5").get(0).play();
    }
    function c(a, b) {
      var c = this.core.$slide.eq(b).find(".lg-video-cont");
      c.hasClass("lg-has-iframe") || (c.css("max-width", this.core.s.videoMaxWidth), this.videoLoaded = !0);
    }
    function d(b, c, d) {
      var e = this,
        f = e.core.$slide.eq(c),
        g = f.find(".lg-youtube").get(0),
        h = f.find(".lg-vimeo").get(0),
        i = f.find(".lg-dailymotion").get(0),
        j = f.find(".lg-vk").get(0),
        k = f.find(".lg-html5").get(0);
      if (g) g.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");else if (h) try {
        new Vimeo.Player(h).pause().catch(function (a) {
          console.error("Unable to pause the video:", a.name);
        });
      } catch (a) {
        console.warn("lightGallery:- Make sure you have included https://github.com/vimeo/player.js");
      } else if (i) i.contentWindow.postMessage("pause", "*");else if (k) if (e.core.s.videojs) try {
        videojs(k).pause();
      } catch (a) {
        console.error("lightGallery:- Make sure you have included videojs");
      } else k.pause();
      j && a(j).attr("src", a(j).attr("src").replace("&autoplay", "&noplay"));
      var l;
      l = e.core.s.dynamic ? e.core.s.dynamicEl[d].src : e.core.$items.eq(d).attr("href") || e.core.$items.eq(d).attr("data-src");
      var m = e.core.isVideo(l, d) || {};
      (m.youtube || m.vimeo || m.dailymotion || m.vk) && e.core.$outer.addClass("lg-hide-download");
    }
    var e = {
        videoMaxWidth: "855px",
        autoplayFirstVideo: !0,
        youtubePlayerParams: !1,
        vimeoPlayerParams: !1,
        dailymotionPlayerParams: !1,
        vkPlayerParams: !1,
        videojs: !1,
        videojsOptions: {}
      },
      f = function (b) {
        return this.core = a(b).data("lightGallery"), this.$el = a(b), this.core.s = a.extend({}, e, this.core.s), this.videoLoaded = !1, this.init(), this;
      };
    f.prototype.init = function () {
      var e = this;
      e.core.$el.on("hasVideo.lg.tm", b.bind(this)), e.core.$el.on("onAferAppendSlide.lg.tm", c.bind(this)), e.core.doCss() && e.core.$items.length > 1 && (e.core.s.enableSwipe || e.core.s.enableDrag) ? e.core.$el.on("onSlideClick.lg.tm", function () {
        var a = e.core.$slide.eq(e.core.index);
        e.loadVideoOnclick(a);
      }) : e.core.$slide.on("click.lg", function () {
        e.loadVideoOnclick(a(this));
      }), e.core.$el.on("onBeforeSlide.lg.tm", d.bind(this)), e.core.$el.on("onAfterSlide.lg.tm", function (a, b) {
        e.core.$slide.eq(b).removeClass("lg-video-playing");
      }), e.core.s.autoplayFirstVideo && e.core.$el.on("onAferAppendSlide.lg.tm", function (a, b) {
        if (!e.core.lGalleryOn) {
          var c = e.core.$slide.eq(b);
          setTimeout(function () {
            e.loadVideoOnclick(c);
          }, 100);
        }
      });
    }, f.prototype.loadVideo = function (b, c, d, e, f) {
      var g,
        h = this,
        i = "",
        j = 1,
        k = "",
        l = this.core.isVideo(b, e) || {};
      if (g = h.core.s.dynamic ? h.core.s.dynamicEl[h.core.index].title : h.core.$items.eq(h.core.index).attr("title") || h.core.$items.eq(h.core.index).find("img").first().attr("alt"), g = g ? 'title="' + g + '"' : "", d && (j = this.videoLoaded ? 0 : this.core.s.autoplayFirstVideo ? 1 : 0), l.youtube) k = "?wmode=opaque&autoplay=" + j + "&enablejsapi=1", this.core.s.youtubePlayerParams && (k = k + "&" + a.param(this.core.s.youtubePlayerParams)), i = '<iframe allow="autoplay" class="lg-video-object lg-youtube ' + c + '" ' + g + ' width="560" height="315" src="//www.youtube.com/embed/' + l.youtube[1] + k + '" frameborder="0" allowfullscreen></iframe>';else if (l.vimeo) k = "?autoplay=" + j, this.core.s.vimeoPlayerParams && (k = k + "&" + a.param(this.core.s.vimeoPlayerParams)), i = '<iframe allow="autoplay" class="lg-video-object lg-vimeo ' + c + '" ' + g + ' width="560" height="315"  src="//player.vimeo.com/video/' + l.vimeo[1] + k + '" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>';else if (l.dailymotion) k = "?wmode=opaque&autoplay=" + j + "&api=postMessage", this.core.s.dailymotionPlayerParams && (k = k + "&" + a.param(this.core.s.dailymotionPlayerParams)), i = '<iframe allow="autoplay" class="lg-video-object lg-dailymotion ' + c + '" ' + g + ' width="560" height="315" src="//www.dailymotion.com/embed/video/' + l.dailymotion[1] + k + '" frameborder="0" allowfullscreen></iframe>';else if (l.html5) {
        var m = f.substring(0, 1);
        "." !== m && "#" !== m || (f = a(f).html()), i = f;
      } else l.vk && (k = "&autoplay=" + j, this.core.s.vkPlayerParams && (k = k + "&" + a.param(this.core.s.vkPlayerParams)), i = '<iframe allow="autoplay" class="lg-video-object lg-vk ' + c + '" ' + g + ' width="560" height="315" src="//vk.com/video_ext.php?' + l.vk[1] + k + '" frameborder="0" allowfullscreen></iframe>');
      return i;
    }, f.prototype.loadVideoOnclick = function (a) {
      var b = this;
      if (a.find(".lg-object").hasClass("lg-has-poster") && a.find(".lg-object").is(":visible")) if (a.hasClass("lg-has-video")) {
        var c = a.find(".lg-youtube").get(0),
          d = a.find(".lg-vimeo").get(0),
          e = a.find(".lg-dailymotion").get(0),
          f = a.find(".lg-html5").get(0);
        if (c) c.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "*");else if (d) try {
          new Vimeo.Player(d).play().catch(function (a) {
            console.error("error playing the video:", a.name);
          });
        } catch (a) {
          console.warn("lightGallery:- Make sure you have included https://github.com/vimeo/player.js");
        } else if (e) e.contentWindow.postMessage("play", "*");else if (f) if (b.core.s.videojs) try {
          videojs(f).play();
        } catch (a) {
          console.error("lightGallery:- Make sure you have included videojs");
        } else f.play();
        a.addClass("lg-video-playing");
      } else {
        a.addClass("lg-video-playing lg-has-video");
        var g,
          h,
          i = function (c, d) {
            if (a.find(".lg-video").append(b.loadVideo(c, "", !1, b.core.index, d)), d) if (b.core.s.videojs) try {
              videojs(b.core.$slide.eq(b.core.index).find(".lg-html5").get(0), b.core.s.videojsOptions, function () {
                this.play();
              });
            } catch (a) {
              console.error("lightGallery:- Make sure you have included videojs");
            } else b.core.$slide.eq(b.core.index).find(".lg-html5").get(0).play();
          };
        b.core.s.dynamic ? (g = b.core.s.dynamicEl[b.core.index].src, h = b.core.s.dynamicEl[b.core.index].html, i(g, h)) : (g = b.core.$items.eq(b.core.index).attr("href") || b.core.$items.eq(b.core.index).attr("data-src"), h = b.core.$items.eq(b.core.index).attr("data-html"), i(g, h));
        var j = a.find(".lg-object");
        a.find(".lg-video").append(j), a.find(".lg-video-object").hasClass("lg-html5") || (a.removeClass("lg-complete"), a.find(".lg-video-object").on("load.lg error.lg", function () {
          a.addClass("lg-complete");
        }));
      }
    }, f.prototype.destroy = function () {
      this.videoLoaded = !1;
    }, a.fn.lightGallery.modules.video = f;
  }();
});